export default "__VITE_ASSET__DcaUeGRu__"